import { ApiResource } from '@/core/models/ApiResource.interface';
import { LocationQuery } from 'vue-router';
import { CustomerDocumentType } from './customer-document-type.interface';

export class CustomerDocumentTypeService {
   async getCustomerDocumentTypes(params?: LocationQuery) {
      return await http.get<ApiResource<Array<CustomerDocumentType>>>(`/customer-document-types`, {
         ...cacheFirstConfig,
         params: { ...params },
      });
   }
}
